<template>
  <section>
    <PageHeader />
    <ArticlePageFullArticle :article="pageData" />
    <PageFooter />
  </section>
</template>

<script setup>
  import { getCurrentInstance } from 'vue'
  import { useYoastData } from '@/composables/useYoastData'

  const route = useRoute()
  const { injectYoastDataFrom } = useYoastData()

  const app = getCurrentInstance()
  const store = app.appContext.config.globalProperties.$store

  const { data: pageData, error } = await useAsyncData(() =>
    store.dispatch('pageutil/xFetchPostWithSlug', route.params.slug)
  )

  if (error.value) {
    throw createError({ statusCode: 500, statusMessage: 'Page Error' })
  }

  if (!pageData.value) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
  }

  injectYoastDataFrom(pageData.value.yoast_head_json.title, pageData.value.yoast_meta)
</script>
